import { useAuth } from "../provider/auth";
import { Navigate, useLocation } from "react-router-dom";

export function PrivateRoute({ children }) {
  const { auth } = useAuth();
  let location = useLocation();

  /*   if(auth.cookies){
    authActions.getCookies('config')
  } */

  if (!auth.user) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/401" state={{ from: location }} replace />;
  }
  return children;
}
